import React, { FC, Fragment, ReactElement, useContext, useState } from 'react'
import {
    Color,
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from '@material-ui/lab'
import IconButton, { IconButtonType } from '../../../../React/Common/Components/IconButton'
import Icon, { IconName } from '../../../../React/Common/Components/Icon'
import { ServiceMessage } from '../../Organisms/WelcomeContainer/Types'
import { useMessages } from '../../../Hooks/useMessages'
import { ArrayUtils } from '../../../../NonReact/utils/ArrayUtils'
import { IsVarEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { Modal } from '../Modal/Modal'
import { ReactState } from '../../../../React/Common/Types/Types'
import { LanguageUtils } from '../../../../React/Common/Utils/LanguageUtils'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../React/Common/Contexts'
import { ServiceMessagesLanguage } from '../../../../../i18n'

export const ServiceMessagesTimeline: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(ServiceMessagesLanguage.NAME)

    const serviceMessages: Nullable<ServiceMessage[]> = useMessages()

    const [isTimelineOpen, setIsTimelineOpen]: ReactState<boolean> = useState<boolean>(false)

    const getIconName = (type: Color): IconName => {
        switch (type) {
            case 'error':
                return IconName.ALARM
            case 'info':
                return IconName.INFO
            case 'success':
                return IconName.CHECK
            case 'warning':
                return IconName.WARNING
            default:
                return IconName.INFO
        }
    }

    return IsVarEmpty(serviceMessages) || ArrayUtils.isEmpty(serviceMessages) ? (
        <></>
    ) : (
        <div className='service-messages-container'>
            <IconButton
                customClassName='smc-icon'
                iconName={IconName.ALARM}
                type={IconButtonType.BUTTON}
                onClick={(): void => setIsTimelineOpen(true)}
            />
            <Modal
                className='wc-service-message-modal'
                isOpen={isTimelineOpen}
                onClose={(): void => setIsTimelineOpen(false)}
            >
                <h2 className='smm-title'>{language.get(ServiceMessagesLanguage.ServiceMessages_Timeline_Title)}</h2>
                <Timeline>
                    {serviceMessages?.map(
                        ({ id, description, type, startDate }: ServiceMessage, index: number): ReactElement => (
                            <TimelineItem className='service-timeline-entry' key={`service-timeline-entry${id}`}>
                                <TimelineOppositeContent className='ste-date'>
                                    {LanguageUtils.formatLanguageEntry(startDate ?? EMPTY_STRING)}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot className={`ste-dot-${type}`}>
                                        <Icon iconName={getIconName(type)} />
                                    </TimelineDot>
                                    {index !== serviceMessages.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent className='ste-content'>
                                    {LanguageUtils.formatLanguageEntry(description ?? EMPTY_STRING)}
                                </TimelineContent>
                            </TimelineItem>
                        )
                    )}
                </Timeline>
            </Modal>
        </div>
    )
}
